import { Breadcrumbs, Link, Typography } from "@mui/material";
import { JSX } from "react";

export interface BreadCrumProps {
  linkText: string;
  linkHref: string;
}

export interface BreadcrumbsContainerProps {
    breadcrums: BreadCrumProps[];
}

export const BreadcrumbComponent = ({ breadcrums }: BreadcrumbsContainerProps): JSX.Element => {
  
    return (
      <Breadcrumbs aria-label="breadcrum" sx={{ marginBottom: "8px"}}>
        {breadcrums.map((crum, crumIndex) => {
          if (crumIndex == (breadcrums.length - 1)) {
            return (
              <Typography sx={{ color: 'text.primary' }} key={`breadcrum-${crumIndex}`}>{crum.linkText}</Typography>
            );
          }
          return (
            <Link underline="hover" color="inherit" key={`breadcrum-${crumIndex}`} href={crum.linkHref}>
              {crum.linkText}
            </Link>
          );
        })}
      </Breadcrumbs>
    );
}